export default {"src":"/spend-avios/rewards/_next/static/media/british-airways-logo.f9fa5372.svg","height":73,"width":432,"blurWidth":0,"blurHeight":0};